import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import {
    IColumnDescription,
    GridColumnDescription,
    FormGroupDescription,
} from '@bds/railtrac-models';
import { nameof, TwoWayAdapter, IModelMetadata, From } from '@bds/core';

export class RtvAutoCarAssign implements From<RtvAutoCarAssign> {
    constructor(
        public ormId?: number,
        public commClass?: string,
        public splc?: string,
        public erpcOrigin?: string,
        public erpcState?: string,
        public fleetId?: string,
        public businessGroup?: string,
    ) {}

    from(autoCarAssign: RtvAutoCarAssign): RtvAutoCarAssign {
        Object.keys(autoCarAssign).forEach((k) => (this[k] = autoCarAssign[k]));
        return this;
    }
}

export const relationship: IModelMetadata[] = [
    { client: nameof<RtvAutoCarAssign>('ormId'), server: 'ormId' },
    { client: nameof<RtvAutoCarAssign>('commClass'), server: 'commClass' },
    { client: nameof<RtvAutoCarAssign>('splc'), server: 'splc' },
    { client: nameof<RtvAutoCarAssign>('erpcOrigin'), server: 'erpcOrigin' },
    { client: nameof<RtvAutoCarAssign>('erpcState'), server: 'erpcState' },
    { client: nameof<RtvAutoCarAssign>('fleetId'), server: 'fleetId' },
    { client: nameof<RtvAutoCarAssign>('businessGroup'), server: 'businessGroup' },
];

@Injectable({
    providedIn: 'root',
})
export class RtvAutoCarAssignAdapter extends TwoWayAdapter<RtvAutoCarAssign> {
    constructor() {
        super();
    }
    public metadata: IModelMetadata[] = relationship;
}

@Injectable({
    providedIn: 'root',
})
export class RtvAutoCarAssignMetadata implements GridColumnDescription, FormGroupDescription {
    getColumns(defaultVisibility = true): IColumnDescription[] {
        const columns = [
            {
                dataField: nameof<RtvAutoCarAssign>('ormId'),
                dataType: 'number',
                caption: 'ORM Id',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvAutoCarAssign>('commClass'),
                dataType: 'string',
                caption: 'Commodity Class',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvAutoCarAssign>('splc'),
                dataType: 'string',
                caption: 'SPLC',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvAutoCarAssign>('erpcOrigin'),
                dataType: 'string',
                caption: 'ERPC Origin',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvAutoCarAssign>('erpcState'),
                dataType: 'string',
                caption: 'ERPC State',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvAutoCarAssign>('fleetId'),
                dataType: 'string',
                caption: 'Fleet',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvAutoCarAssign>('businessGroup'),
                dataType: 'string',
                caption: 'Business Group',
                visible: defaultVisibility,
            } as IColumnDescription,
        ];
        return columns;
    }

    getFormGroup(obj?: any): UntypedFormGroup {
        const formGroup = new UntypedFormGroup({});
        formGroup.addControl(nameof<RtvAutoCarAssign>('ormId'), new UntypedFormControl(''));
        formGroup.addControl(
            nameof<RtvAutoCarAssign>('commClass'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtvAutoCarAssign>('splc'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtvAutoCarAssign>('erpcOrigin'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtvAutoCarAssign>('erpcState'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtvAutoCarAssign>('fleetId'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtvAutoCarAssign>('businessGroup'),
            new UntypedFormControl('', [Validators.required]),
        );

        formGroup.addControl('commCode', new UntypedFormControl('', [Validators.required]));
        if (obj) {
            formGroup.patchValue(obj);
        }
        return formGroup;
    }
}
